import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

const DEVICE_ID_KEY = 'loyalty_device_id';

@Injectable({ providedIn: 'root' })
export class DeviceContextService {
  readonly acceptLanguage = navigator.language;

  deviceId(): string {
    let id = localStorage.getItem(DEVICE_ID_KEY);

    if (!id) {
      id = uuidv4();
      localStorage.setItem(DEVICE_ID_KEY, id);
    }

    return id;
  }
}
